import { Docs } from "./Docs";

export function Qna() {
  return <Docs slug="qna" />;
}
